import { queryOptions, useQuery } from '@tanstack/react-query'

import { getResolutionTargets } from '../api/configApi'
import { RESOLUTION_TARGETS, type ResolutionTargets } from '../lib/resolution-targets'

/** One queryOptions factory per resource (the loader prefetch + every `useQuery` import this). */
export const resolutionTargetsQueryOptions = () =>
  queryOptions({
    queryKey: ['gis', 'config', 'resolution-targets'],
    queryFn: getResolutionTargets,
    staleTime: 60 * 60 * 1000, // rarely changes — cache an hour
  })

/**
 * The live per-severity resolution targets, defaulting to the FE constant until the fetch resolves
 * (or if it fails). Since the default matches the backend's seed values, there's no visible flicker —
 * this only matters if the district tunes the targets server-side.
 */
export function useResolutionTargets(): ResolutionTargets {
  return useQuery(resolutionTargetsQueryOptions()).data ?? RESOLUTION_TARGETS
}
